import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/2 does this sound familiar/webp/cloud.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/Andrei.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/Frame 208.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/Frame 209.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/rockwool.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/Tamara.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/contactSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Alert/Alert.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Button/Button.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Input/Input.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Link/Link.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/LocaleSwitcher/LocaleSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareLink"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/ShareLink/ShareLink.tsx");
